<div *ngIf="loadingInitial || loading" class="overlay">
  <div class="spinner"></div>
</div>
<div id="snackbar"></div>

<app-side-menu (toggle)="toggleCollapse($event)"></app-side-menu>

<head>
  <link rel="stylesheet" href="view-form-page.component.css">
</head>

<body class="green lighten-5" style="min-height: 720px;">
  <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
    <app-navbar></app-navbar>
  </div>

<p *ngIf="loadError && !loadingInitial" class="load-error-banner" role="alert">{{ loadError }}</p>

<div *ngIf="!loadingInitial && currUser && !loadError">
  <div class="main-panel" [class.admin-expanded]="isNavbarExpanded">
    <br>
    <br>
    <br>
    <br>

    <!-- NOTE TO VENDOR CONFIRMATION -->
    <div *ngIf="showNoteConfirmModal" class="modal-overlay">
      <div class="modal-content">
        <h4 style="margin-bottom: 16px;">Send message to vendor?</h4>
        <p style="text-align: left; margin-bottom: 24px; line-height: 1.5;">
          Are you sure you want to send this message? The vendor will be notified by email.
          This action cannot be undone.
        </p>
        <div class="modal-buttons">
          <button type="button" class="outline-btn" (click)="cancelNoteConfirm()">Cancel</button>
          <button type="button" class="btn-solid" (click)="confirmSubmitNote()" [disabled]="loadingNotes">
            Send Message
          </button>
        </div>
      </div>
    </div>

    <!-- SEND BACK MODAL -->
    <div *ngIf="showModal" class="modal-overlay">
      <div class="modal-content">
        <h4 style="margin-bottom: 20px;">Request Vendor for More Information</h4>
        <div class="row">
          <p class="error">{{error_message}}</p>
        </div>

        <div style="text-align: left;">
          <label for="field"
            style="color: gray; font-size: 1rem; font-weight: 500; display: block; margin-bottom: 2px;">
            Select SECTION(S) requiring correction:
          </label>

          <h6 style="color: gray; font-size: 12px; margin-bottom: 5px; text-align: left;">
            The selected sections will be unlocked for the Vendor to make edits.
          </h6>
        </div>

        <div class="input-field">
          <select style="display: block; height: 150px;" id="opts" name="opts" multiple required
            (change)="updateSelectedOptions($event)">
            <option *ngFor="let field of formSections" [value]="field" style="padding: 10px 0px;">{{ field }}</option>
          </select>
        </div>

        <div *ngIf="selectedFields.length > 0" style="text-align: left;">
          <h6 style="display: inline-block;"><b>Selected:</b></h6>
          <ul style="display: inline-block;" class="type-list">
            <li class="type-item" *ngFor="let select of selectedFields; let i = index">
              <button class="remove-btn" (click)="removeType(i)"><i
                  class="material-icons tiny icon-inline">clear</i></button>
              <span>{{ select }}</span>
            </li>
          </ul>
        </div>


        <textarea [(ngModel)]="commentText" rows="5" placeholder="Add your comment here..." class="materialize-textarea"
          required></textarea>

        <div class="modal-buttons">
          <button class="outline-btn" (click)="closeModal()">Cancel</button>
          <button class="btn-solid" (click)="sendRequest()">Send</button>
        </div>
      </div>
    </div>


    <!-- ADMIN VIEW -->
    <div *ngIf="showCard && isAdminUser && viewUser" class="response-card">
      <div class="col">
        <div class="row s12">
          <div class="admin-actions-header">
            <div class="admin-actions-text">
              <h3><b>Form Actions</b></h3>
              <h6 style="color: gray; font-size: 12px; margin-bottom: 0px;">This section is visible to Procurement Staff
                members only. Any changes made will reflect for all team
                members, and will be logged in the <a href="/admin" style="color: rgb(0, 153, 255);">Admin Hub. </a> </h6>
              <h6 style="color: gray; font-size: 12px; padding-top: 0px;">NOTE: Flagging a user will be visible to all team
                members.</h6>
            </div>

            <div class="status-block">
              <div class="status-pill" [ngClass]="viewUserStatusPillClass">
                {{ viewUserStatusLabel }}
              </div>
              <div
                *ngIf="isViewUserStatusReady && isAdminUser && shouldShowStatusMeta(viewUser)"
                class="status-meta"
              >
                By: {{ statusActor?.strName || 'Unknown' }} on {{ formatStatusTimestamp(viewUser?.strAccountStatusDate) }}
              </div>
            </div>
          </div>
        </div>

  
        <div style="text-align: right;">
          <button
            (click)="unflagAccount(viewUser)"
            *ngIf="viewUser?.blnFlagged == true"
            class="icon-button flag-icon-btn"
            [disabled]="flagUpdating"
            [attr.aria-busy]="flagUpdating"
            title="Flagged — click to unflag">
            <span *ngIf="flagUpdating; else flaggedIcon" class="flag-btn-spinner" aria-hidden="true"></span>
            <ng-template #flaggedIcon>
              <i class="material-icons" style="font-size: 30px;">turned_in</i>
            </ng-template>
          </button>

          <button
            (click)="flagForFollowUp(viewUser)"
            *ngIf="!viewUser?.blnFlagged"
            class="icon-button flag-icon-btn"
            [disabled]="flagUpdating"
            [attr.aria-busy]="flagUpdating"
            title="Flag for follow-up">
            <span *ngIf="flagUpdating; else unflaggedIcon" class="flag-btn-spinner" aria-hidden="true"></span>
            <ng-template #unflaggedIcon>
              <i class="material-icons" style="font-size: 30px; color: black">turned_in_not</i>
            </ng-template>
          </button>
        </div>

        <div class="row s12" style="display: flex; justify-content: center;">
          <button (click)="openModal()" class="outline-btn" style="margin-right: 8px; font-size: medium;"
            [disabled]="!isViewUserStatusReady || viewUser?.strAccountStatus == 'Vendor Action Required'">Send Back</button>
          <button (click)="decline(viewUser)" class="outline-btn"
            style="margin-right: 8px; border-color: brown; color: brown; font-size: medium;">Decline</button>
          <button (click)="approve(viewUser)" class="btn-solid" style="font-size: medium;">Approve</button>
        </div>


        <div class="notes-section">
          <div class="note-header">
            <h5>Messages & Send Back Requests to Vendor</h5>
            <button (click)="showHistory = !showHistory" class="history-toggle-btn">
              {{ showHistory ? 'Hide History' : 'Show History' }}
            </button>
          </div>

          <div *ngIf="loadingNotes" class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
  
          <!-- Send Back Notificiations -->
            <!-- Most Recent Notification -->
            <div class="note" *ngIf="latestNoti">

              <p class="open-pill">Most Recent</p>
              <p *ngIf="latestNoti.message" class="wrap-text"><b>Send Back Request: </b> {{ latestNoti?.message }}</p>
              <div><b>Sections: </b></div>
              <div class="vendor-notification-chips">
                <div class="vendor-chip" *ngFor="let field of latestNoti?.fieldNames">
                  {{ field }}
                </div>
              </div>
              <span class="note-meta">
                {{ formatDate(latestNoti.createdAt) }} {{ latestNoti.creator?.strName }}
              </span>
            </div>


            <!-- Older Notifications -->
            <div *ngIf="showHistory">
              <div class="note" *ngFor="let noti of notifications" [hidden]="noti === latestNoti">
                <p class="closed-pill">Closed</p>
                <p class="wrap-text"><b>Send Back Request: </b> {{ noti?.message }}</p>
                <div><b>Sections: </b></div>
                <div class="vendor-notification-chips">
                  <div class="vendor-chip" *ngFor="let field of noti?.fieldNames">
                    {{ field }}
                  </div>
                </div>
                <span class="note-meta">
                  {{ formatDate(noti.createdAt) }} {{ noti.creator?.strName }}
                </span>
              </div>
            </div>

          <!-- Notes Display -->
          <div class="note" *ngFor="let note of notes">
            <p>{{ note.content }}</p>
            <span class="note-meta">
              {{ formatDate(note.createdAt) }} {{note.creator?.strName}}
              <button class="delete-btn" (click)="deleteNote(note.id)">
                <i class="material-icons">delete</i>
              </button>
            </span>
          </div>

          <!-- Add New Note -->
          <form (ngSubmit)="openNoteConfirmModal(viewUser?.company?.intCompanyPK)">
            <textarea [(ngModel)]="newNote" name="note" placeholder="Write a note..." required></textarea>
            <button type="submit" class="btn-solid">Add Note</button>
          </form>
        </div>

      </div>
    </div>
    <!-- END OF ADMIN VIEW -->

    <!-- VENDOR VIEW -->
    <div class="row">
      <div *ngIf="currUser?.role == 'Vendor'" class="status-block">
        <div class="status-pill" [ngClass]="viewUserStatusPillClass">
          {{ viewUserStatusLabel }}
        </div>
      </div>
    </div>
    <!-- Banner if under review -->
    <div *ngIf="showCard && currUser?.role == 'Vendor' && isViewUserStatusReady && currUser?.strAccountStatus == 'Under Review'"
      class="noti-card">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <h6 style="font-size: small; display: flex; align-items: center; margin: 0;">
          <i class="material-icons tiny" style="margin-right: 10px;">info_outline</i>
          Your registration is currently under review. Once approved, you will be notified via email.
        </h6>
        <button (click)="showCard = false" class="delete-btn"
          style="background: none; border: none; cursor: pointer; padding: 0; margin-left: 10px; margin-right: 10px;">
          <i class="material-icons icon-inline">clear</i>
        </button>
      </div>
    </div>
    <!-- Vendor SEND BACK notis: -->
    <div *ngIf="showCard && currUser?.role === 'Vendor' && isViewUserStatusReady && currUser?.strAccountStatus === 'Vendor Action Required'"
      class="vendor-notification-card">
      <div class="vendor-notification-header">
        <h6 class="vendor-notification-title">
          <i class="material-icons">info_outline</i>
          The following section(s) have been unlocked for changes to be made. Don't forget to resubmit your changes.
        </h6>
      </div>

      <div class="vendor-notification-body">
        <div class="vendor-notification-fields-label"><strong>Section(s) to review:</strong></div>
        <div class="vendor-notification-chips">
          <span class="vendor-chip" *ngFor="let field of latestNoti?.fieldNames">
            {{ field }}
          </span>
        </div>
        <p class="vendor-notification-message" style="margin-top: 20px;">
          <strong>Request Message: </strong>{{ latestNoti?.message }}
        </p>
        <div class="vendor-notification-date">
          {{ formatDate(latestNoti?.createdAt) }}
        </div>
      </div> 

<!-- this was used to display all send back request past included -->
      <!-- <div class="vendor-notification-body" *ngFor="let noti of notifications">
        <p *ngIf="noti != latestNoti" class="closed-pill">Closed</p>
        <p *ngIf="noti === latestNoti" class="open-pill">Pending</p>
        <div class="vendor-notification-fields-label"><strong>Section(s) to review:</strong></div>
        <div class="vendor-notification-chips">
          <span class="vendor-chip" *ngFor="let field of noti?.fieldNames">
            {{ field }}
          </span>
        </div>
        <p class="vendor-notification-message" style="margin-top: 20px;">
          <strong>Request Message: </strong>{{ noti?.message }}
        </p>
        <div class="vendor-notification-date">
          {{ formatDate(noti.createdAt) }}
        </div>
      </div> -->
    </div>


    <!-- END OF VENDOR VIEW -->

  
    <div class="card" style="border-radius: 10px; background-color: white;">
      <div class="filter-row">
        <div>
          <h3><b>{{title}}</b></h3>
          <h6 style="color: gray;">Date Created: {{ submissiondate | date: 'MMM d, y' }}</h6>
        </div>

        <p *ngIf="resubmit_error_message" class="error" role="alert" style="color: #c62828; margin: 8px 0; width: 100%;">
          {{ resubmit_error_message }}</p>
        <div class="filter-buttons">
          <button type="button"
            *ngIf="isViewUserStatusReady && currUser?.role === 'Vendor' && currUser?.strAccountStatus === 'Vendor Action Required'"
            class="submit-btn" (click)="resubmitForm()">RE-SUBMIT
          </button>
          <button class="outline-btn" style="border-color: rgb(161, 161, 161); color: rgb(161, 161, 161);">
            <i class="tiny icon-inline material-icons">arrow_upward</i>
            Export to Email
          </button>
          <button class="btn-solid" style="background-color: rgb(161, 161, 161);" (click)="downloadAsCsv()">
            <i class="tiny icon-inline material-icons">arrow_downward</i>
            Download CSV
          </button>
        </div>
      </div>

      <p *ngIf="loadingFormDetails" class="form-loading-hint" aria-live="polite">
        Loading registration sections…
      </p>

      <div *ngIf="loadingFormDetails" class="form-section-skeletons" aria-busy="true" aria-label="Loading form sections">
        <div *ngFor="let _ of sectionSkeletonIndices" class="section-skeleton-block">
          <span class="skeleton skeleton-heading"></span>
          <span class="skeleton skeleton-text"></span>
          <span class="skeleton skeleton-text short"></span>
          <span class="skeleton skeleton-text"></span>
        </div>
      </div>

      <div class="form-container" *ngIf="submittedData && !loadingFormDetails">
        <h1>Section 1</h1>
        <app-a-customer-info [isViewOnly]="!(latestNoti?.fieldNames.includes('Sec. 1: Vendor Information, Type of Organization and Business') && currUser?.role === 'Vendor')" [isOriginalSubmission]="false" [formData]="submittedData"></app-a-customer-info>
        <h1>Section 2</h1>
        <app-c-documents-form [isViewOnly]="!(latestNoti?.fieldNames.includes('Sec. 2: Regulatory/Statutory Documents') && currUser?.role === 'Vendor')" [formData]="submittedData"></app-c-documents-form>
        <h1>Section 3</h1>
        <app-d-directors-authority-form [isViewOnly]="!(latestNoti?.fieldNames.includes('Sec. 3: Information on Directors, Authorized Persons, Affiliated/Holding Subs...') && currUser?.role === 'Vendor')" [formData]="submittedData"></app-d-directors-authority-form>
        <h1>Section 4</h1>
        <app-e-top-customers [isViewOnly]="!(latestNoti?.fieldNames.includes('Sec. 4: Major Customers, Subcontracts and Primary Works')  && currUser?.role === 'Vendor')" [formData]="submittedData"></app-e-top-customers>
        <h1>Section 5</h1>
        <app-f-health-safety [isViewOnly]="!(latestNoti?.fieldNames.includes('Sec. 5: Health & Safety, Sustainability Checklist')  && currUser?.role === 'Vendor')" [formData]="submittedData"></app-f-health-safety>
        <h1>Policies</h1>
        <app-g-terms-conditions [isViewOnly]="!(latestNoti?.fieldNames.includes('Sec. 6: Signed T&Cs, Signed Code of Conduct and Ethics')  && currUser?.role === 'Vendor')" [formData]="submittedData"></app-g-terms-conditions>
      </div>

    </div>

  </div>

  </div>
</body>

<!-- <router-outlet></router-outlet> -->